import { FinancialState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';

export const getters = {
  Financials: (state: FinancialState) => state.financials,
  UnattestedAppointments: (state: FinancialState) => state.unattestedAppointments,
  AppointmentsWithoutPrescription: (state: FinancialState) => state.appointmentsWithoutPrescription
};

const { read } = getStoreAccessors<FinancialState, State>('');

export const readFinancials = read(getters.Financials);
export const readUnattestedAppointments = read(getters.UnattestedAppointments);
export const readAppointmentsWithoutPrescription = read(getters.AppointmentsWithoutPrescription);